import { useQuery } from '@tanstack/react-query';
import {
  brokerageFirmControllerGetBrokerageFirmQueryOptions,
  legacyPermissionsControllerAtMeQueryOptions,
} from 'korint-sdk';

export function useFirmType() {
  const { data: user } = useQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
  });

  const { data: { firmType } = {} } = useQuery({
    ...brokerageFirmControllerGetBrokerageFirmQueryOptions(user?.brokerageFirmId!),
    enabled: !!user?.brokerageFirmId,
  });

  return { firmType, user };
}

export function isLineVisibleForRole(line: { forTypes: string[] }, firmType: string | undefined) {
  if (line.forTypes.length === 0) return true;
  if (!firmType) return false;
  return line.forTypes.includes(firmType);
}
